const notes = [
  {
    title: 'Not a chatbot',
    body: 'Compound is a method and memory system for Cursor — skills, orchestration, and accumulated project knowledge. It is not a hosted agent that ships without you.',
  },
  {
    title: 'Not a substitute for seniors',
    body: 'AI accelerates volume. Architecture, merge judgment, and production accountability stay with experienced engineers. Compound strengthens senior-led delivery; it does not replace it.',
  },
  {
    title: 'Prerequisite: Cursor',
    body: 'You bring the IDE and the repository. Compound provides the evolving skill system, memory model, and orchestration method. Built for teams already working in Cursor.',
  },
]

export function CompoundCaution() {
  return (
    <section id="notes" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 py-12 lg:px-8 lg:py-16">
        <div className="border-2 border-overprint">
          <div className="border-b-2 border-overprint px-5 py-4 sm:px-7">
            <h2 className="section-title text-ink">What Compound is not</h2>
          </div>

          <div className="grid divide-y divide-overprint/40 lg:grid-cols-3 lg:divide-x lg:divide-y-0">
            {notes.map((note) => (
              <article key={note.title} className="px-5 py-6 sm:px-7 lg:py-7">
                <h3 className="entry-title text-ink">{note.title}</h3>
                <p className="mt-3 text-[0.9375rem] leading-relaxed text-ink-muted">
                  {note.body}
                </p>
              </article>
            ))}
          </div>
        </div>

        <p className="mt-5 max-w-3xl text-base leading-relaxed text-ink-muted">
          For Head of Engineering and CTO buyers who want an adaptive full-SDLC
          method — not another opaque AI vendor promise.
        </p>
      </div>
    </section>
  )
}
